export default "__VITE_ASSET__BaLn5bc3__"